import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { COLORES } from '../../../../config/colores'
import DetalleCerealAsignadoAVolcadora from './DetalleCerealAsignadoAVolcadora'

function CerealAsignadoAVolcadora (props) {
  const { volcadorasConCereal, calleDeVolcadora } = props
  const [dataVolcadoras, setDataVolcadoras] = useState(null)

  useEffect(() => {
    const volcadoras = []
    volcadorasConCereal && volcadorasConCereal.map((v) => {
      if (v.claveVolcadora.trim() === 'LINEAA') {
        const volcadora = {
          claveVolcadora: v.claveVolcadora,
          calleDeVolcadora: null,
          claveCereal: v.claveCereal,
          calle: null,
          habilitado: true
        }
        return volcadoras.push(volcadora)
      } else {
        const calle = calleDeVolcadora && calleDeVolcadora.find((c) => c.volcadora === v.claveVolcadora)
        const volcadora = {
          claveVolcadora: v.claveVolcadora,
          claveCalle: calle.nombreCorto,
          claveCereal: v.claveCereal,
          calle: (calle.nombre),
          habilitado: calle.habilitado

        }
        return volcadoras.push(volcadora)
      }
    })
    setDataVolcadoras(volcadoras)
  }, [volcadorasConCereal, calleDeVolcadora])

  const renderVolcadoras = () => {
    const volcadoras = dataVolcadoras && dataVolcadoras.map((v) => {
      return (
        <DetalleCerealAsignadoAVolcadora
          volcadora={v}
          key={v.claveVolcadora}
          setHabilitacionVolcadora={props.setHabilitacion}
        />
      )
    })

    return volcadoras
  }

  return (
    dataVolcadoras && <Card className='shadow bg-white rounded' >
      <h6
        style={{
          backgroundColor: COLORES.grey.dark,
          textAlign: 'center',
          color: '#ffffff',
          padding: '8px',
          borderRadius: '8px 8px 0 0',
          margin: 0
        }}
      >
            Cereal asignado en volcadoras
      </h6>

      <div className='container-volcadoras-cereales'>
        {renderVolcadoras()}
      </div>
    </Card>
  )
}

export default CerealAsignadoAVolcadora
